// import axiosInstance, {setBaseURL} from '../axiosInstance';
import apiClient from "./axiosInstanceStock";

// Adding the owner-related function
export const createStock = async (stockData) => {
  return await apiClient.post("/v1/stocks/upsert", stockData);
};

export const updateAvailableQuantity = async (quantityData) => {

  return await apiClient.post("updateavailablequantity", quantityData);
};


export const getAuthToken = async () => {
  const response = await apiClient.post("auth");
  return response.data.token;
}